import {t} from 'i18next'

import {SalutationEnum, SalutationTypeEnum} from '@sdox/api'

import type {PostProcessorModule, TOptions} from 'i18next'

export default {
  type: 'postProcessor',
  name: 'customContext',
  process: (value: string, key: string | string[], options: TOptions) => {
    if (!options) return value

    const {formalityEnum, genderEnum, ...restOptions} = options
    let newOptions = restOptions
    const addOpt = (name: string, value: string) => {
      newOptions = {[name]: t(`${key[0]}_${value}`), ...newOptions}
    }

    if (formalityEnum === SalutationTypeEnum.TypeFormalSalutation) {
      addOpt('formality', 'formal')
    } else if (formalityEnum === SalutationTypeEnum.TypeInformalSalutation) {
      addOpt('formality', 'informal')
    }

    if (genderEnum === SalutationEnum.Herr) {
      addOpt('gender', 'male')
    } else if (genderEnum === SalutationEnum.Frau) {
      addOpt('gender', 'female')
    }

    if (!Object.is(newOptions, restOptions)) {
      return t(key, newOptions)
    }

    return value
  },
} satisfies PostProcessorModule
